import React, { useState, useContext } from 'react'
import ContactUs from '../../components/ContactUs'
import RichContent from '../../components/RichContent'
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions'
import PostPurchaseZone from './PostPurchaseZone'
import CtaTypeEnum from '../../../common/constants/CtaTypeEnum.js'
import { PDP_SUPPORT_ID } from '../../constants/PDPConstants.js'
import { Translations } from '../../services/TranslationService'
import { StateContext } from '../../services/StateService.jsx'
import '../../css/Support.scss'

const formObj = (lightbox, id, title, label, richContentObj, description) => {
    if (!richContentObj?.html || lightbox) return undefined
    return {
        id,
        title,
        label,
        richContentObj,
        description
    }
}
const initialState = (richContent, ctaInfo) => {
    const { leadForm, leadForm2, contactAcquisition } = richContent || {}
    const {
        leadFormTitle,
        leadFormTitle2,
        leadFormLabel,
        leadFormLabel2,
        leadFormDescription,
        leadFormDescription2,
        contactAcquisitionLabel,
        contactAcquisitionTitle,
        contactAcquisitionFormDescription
    } = ctaInfo || {}

    return [
        formObj(
            leadForm?.isLeadLightbox,
            CtaTypeEnum.LEAD_FORM_1,
            leadFormTitle,
            leadFormLabel,
            leadForm,
            leadFormDescription
        ),
        formObj(
            leadForm2?.isLead2Lightbox,
            CtaTypeEnum.LEAD_FORM_2,
            leadFormTitle2,
            leadFormLabel2,
            leadForm2,
            leadFormDescription2
        ),
        formObj(
            contactAcquisition?.isContactLightbox,
            CtaTypeEnum.CONTACT_ACQUISITION,
            contactAcquisitionTitle,
            contactAcquisitionLabel,
            contactAcquisition,
            contactAcquisitionFormDescription
        )
    ].filter((form) => form !== undefined)
}
const Support = () => {
    const translations = useContext(Translations)
    const { richContent, ctaInfo } = useContext(StateContext)
    const [richContentForms] = useState(initialState(richContent, ctaInfo))

    return (
        <div id={PDP_SUPPORT_ID} className="sps2-pdp_section sps2-pdp_support">
            <h2 className="mds-font_header--2a" tabIndex="-1">
                {translations?.support}
            </h2>
            <PostPurchaseZone />
            <ContactUs />
            {richContent?.faqs && <FrequentlyAskedQuestions />}
            {richContentForms.length > 0 &&
                richContentForms.map((form, i) => (
                    <FormSection
                        id={form.id}
                        key={`${i}_richContentForm`}
                        title={form.title}
                        label={form.label}
                        richContentObj={form.richContentObj}
                        formRef={form.formRef}
                        description={form.description}
                    />
                ))}
        </div>
    )
}
const FormSection = ({ id, title, label, richContentObj, formRef, description }) => {
    const displayTitle = title || label
    return (
        <div
            ref={formRef}
            id={id}
            className="sps2-pdp_richContent--form sps2-pdp_wrap--800"
        >
            {displayTitle && (
                <h3
                    className="mds-font_header--3 sps2-pdp_richContent--form-title"
                    tabIndex="-1"
                >
                    {displayTitle}
                </h3>
            )}
            {description && (
                <p className="mds-font_paragraph sps2-pdp_richContent--form-description">
                    {description}
                </p>
            )}
            <RichContent richContentObj={richContentObj} />
        </div>
    )
}

export default Support
